
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-sync",
  "use": "icon-material-sync-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-sync\"><path d=\"M167.48-156.41v-62.63H291.5l-12.61-10.33q-64.24-52.2-93.84-112.55-29.59-60.36-29.59-135.08 0-108.87 65.37-195.04 65.37-86.18 170.71-117.46v70.13q-75.24 27.57-121.47 94.59-46.24 67.02-46.24 147.78 0 62.04 23.14 107.71 23.14 45.66 62.66 79.18l28.57 19.57V-390h62.63v233.59zm401.98-13.09v-71.13q76.24-27.57 121.47-94.59 45.24-67.02 45.24-147.78 0-47.04-23.26-95.71-23.26-48.66-60.3-86.18l-27.57-24.57V-570h-62.87v-233.59h233.59v62.63H670.5l12.85 12.33q60.48 56.48 90.83 121.2 30.36 64.71 30.36 124.43 0 108.87-64.87 195.54-64.87 86.68-170.21 117.96\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-sync"/>
                </svg>
            );
        };

        Icon.id = "icon-material-sync";

        export default Icon;
    